import { InjectionToken } from '@angular/core';
import { SealedTradingEventsPort } from '../ports/sealed-trading-events.port';

export const SEALED_TRADING_EVENTS_TOKEN = new InjectionToken<SealedTradingEventsPort>(
    'SealedTradingEventsPort'
);


